module.exports = __webpack_public_path__ + "img/2a_Events.b87c29bf.png";